import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';

// SemanticUI components
import { Divider, ListItem, ListIcon, ListHeader, ListDescription, ListContent, List, Grid, Button, Container } from 'semantic-ui-react'

/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Styles
import './object.css';


registerLocale('de', de);
setDefaultLocale('de');


/**
 * 
 * @param {string} file 
 */
const handleFileDownload = (file) => {
  console.log('[file download]', file);
}



const Max2ExportsPDFs = () => {
  // local State
  const [expandList, setExpandList] = useState(false);

  // global State
  const object = useSelector((state) => state.object.data);
  
  // Translations
  const { t } = useTranslation();

  

  // if no pdfs available
  if (!object?.Exports?.PDF || !object?.Exports?.PDF.length) {
    return (
      <>
      <Divider horizontal>{t('object.exports.pdfs.title')}</Divider>
      <Container style={{width: '99%'}} textAlign='center'>
        <p>{t('object.exports.noEntries')}</p>
      </Container>
      </>
    )
  }

  // build pdf items
  const exports = object?.Exports.PDF.map((file, fileKey) => {
    const fdateAt = file?.CreatedAt ? format(new Date(file?.CreatedAt), 'dd.MM.yyyy, HH:mm') + ' Uhr' : '';
    const fdateBy = file?.CreatedBy ? file?.CreatedBy : '';
    if (!expandList && fileKey > 9) {
      return <></>;
    }
    return (
      <ListItem key={fileKey}>
        <ListIcon name='file pdf outline' size='large' verticalAlign='middle' />
        <ListContent>
          <ListHeader as='a' onClick={()=>{handleFileDownload(file.Filepath)}}>{file.Filename}</ListHeader>
          <ListDescription as='a'>{fdateAt}, {fdateBy}</ListDescription>
        </ListContent>
      </ListItem>
    );
  });

  // build list
  return (
    <>
    <Divider horizontal>{t('object.exports.pdfs.title')}</Divider>
    <List relaxed>
      {exports}
    </List>
    <br />
    {!expandList && object?.Exports?.PDF?.length > 10 && (<Button basic circular onClick={()=>setExpandList(true)}>{t('object.exports.actions.more')}</Button>)}
    {expandList && (<Button basic circular onClick={()=>setExpandList(false)}>{t('object.exports.actions.less')}</Button>)}
    </>
  )
}



const Max2ExportsEDFs = () => {
  // local State
  const [expandList, setExpandList] = useState(false);

  // global State
  const object = useSelector((state) => state.object.data);

  // Translations
  const { t } = useTranslation();

  // if no edfs available
  if (!object?.Exports?.EDF || !object?.Exports?.EDF.length) {
    return (
      <>
      <Divider horizontal>{t('object.exports.edfs.title')}</Divider>
      <Container style={{width: '99%'}} textAlign='center'>
        <p>{t('object.exports.noEntries')}</p>
      </Container>
      </>
    )
  }

  // build edf items
  const exports = object?.Exports.EDF.map((file, fileKey) => {
    const fdateAt = file?.CreatedAt ? format(new Date(file?.CreatedAt), 'dd.MM.yyyy, HH:mm') + ' Uhr' : '';
    const fdateBy = file?.CreatedBy ? file?.CreatedBy : '';
    if (!expandList && fileKey > 9) {
      return <></>;
    }
    return (
      <ListItem key={fileKey}>
        <ListIcon name='file excel outline' size='large' verticalAlign='middle' />
        <ListContent>
          <ListHeader as='a' onClick={()=>{handleFileDownload(file.Filepath)}}>{file.Filename}</ListHeader>
          <ListDescription as='a'>{fdateAt}, {fdateBy}</ListDescription>
          <ListDescription as='a'>{t('object.exports.edfs.type')}</ListDescription>
        </ListContent>
      </ListItem>
    );
  });

  // build list
  return (
    <>
    <Divider horizontal>{t('object.exports.edfs.title')}</Divider>
    <List relaxed>
      {exports}
    </List>
    <br />
    {!expandList && object?.Exports?.EDF?.length > 10 && (<Button basic circular onClick={()=>setExpandList(true)}>{t('object.exports.actions.more')}</Button>)}
    {expandList && (<Button basic circular onClick={()=>setExpandList(false)}>{t('object.exports.actions.less')}</Button>)}
    </>
  )
}



const Max2Exports = ({sectionWidth}) => {
  if (sectionWidth === 'S') {
    return (
      <>
        <Max2ExportsPDFs />
        <Max2ExportsEDFs />
      </>
    );
  }

  return (
    <Grid columns={2}>
      <Grid.Column>
        <Max2ExportsPDFs />
      </Grid.Column>
      <Grid.Column>
        <Max2ExportsEDFs />
      </Grid.Column>
    </Grid>
  );
}

export default Max2Exports;